import React from "react";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";
import {Typography} from "@mui/material";

export const ReasoningCell: React.FC<DeserializedGridCellParams<PartGridRowModel>> = ({value}) => {
    if (!value) return <></>
    return <Typography variant="body1" component="p" title={value}>{value}</Typography>
}
